import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

// Create an Axios instance
const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

// Request interceptor to add the Bearer token
api.interceptors.request.use(
    (config) => {
        const token = Cookies.get("authToken");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle errors (like 401 Unauthorized)
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Optional: Clear token and redirect to login if 401 occurs
            // Cookies.remove("authToken");
            // window.location.href = "/login";
            toast.error("Session expired or unauthorized. Please login again.");
        }
        return Promise.reject(error);
    }
);

export default api;
